var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 10"}},[_c('rect',{attrs:{"width":"16","height":"10","fill":"#fff"}}),_c('rect',{attrs:{"width":"16","height":"5","fill":"#dc143c","y":"5"}})])}
var staticRenderFns = []

export { render, staticRenderFns }